import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/services/spinner.service';
import { VersionService } from 'src/app/services/version.service';
import { StorageService } from 'src/app/services/storage.service';
import { basicAlert, obtenerFechaActual } from '../../utils';
import { element } from 'protractor';
import { error } from 'console';
@Component({
  selector: 'app-md-aviso-estado-cuenta-cliente',
  templateUrl: './md-aviso-estado-cuenta-cliente.component.html',
  styleUrls: ['./md-aviso-estado-cuenta-cliente.component.css']
})

export class MdAvisoEstadoCuentaClienteComponent implements OnInit {
  public sessionInfo: any = null;
  facturas:any[];
  public radioValue: string = "S";
  fechaActual;
  facturasVencidas:any[]=[];
  facturasPorVencer:any[]=[];
  constructor( private modalService2: NgbActiveModal,
    private versionService: VersionService,
    private spinnerService:SpinnerService,
    private modalService: NgbModal,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    this.sessionInfo = JSON.parse(StorageService.getSession());
    console.log('Session',this.sessionInfo);
    console.log('Facturasss',this.facturas);
    this.fechaActual =  obtenerFechaActual('YYYY-MM-DD');
    this.filtrarFacturasVencidas();
    this.filtrarFacturasPorVencer();
    this.obtenerGlosa52();
  }
  cerrar(){
    this.modalService2.dismiss('canceling');
  }
  filtrarFacturasVencidas(){
    this.facturasVencidas=this.facturas.filter(element=>this.fechaActual>element.fvenci);
  }
  filtrarFacturasPorVencer(){
    this.facturasPorVencer=this.facturas.filter(element=>this.fechaActual<=element.fvenci);
  }
  esttemp = {
    numint: '',
  };
  onClick(data: any): void {
    this.esttemp = data;
  }
  imprimirComprobante(data:any){
    this.spinnerService.activarLoading(true);
    this.versionService.pdfFormatoDefaultAdmin(data.numint,true).subscribe((response:any)=>{
      this.spinnerService.activarLoading(false);
      if (response.byteLength > 0) {
        let file = new Blob([response], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      } else {
        basicAlert('No se encontraron resultados.', 'warning', 'Aceptar', null, null, null);
      }
    }, err => {
      basicAlert('No se encontraron resultados.', 'warning', 'Aceptar', null, null, null);
      this.spinnerService.activarLoading(false);
    })
  }
  glosa52:string[]=[];
  obtenerGlosa52(){
    this.spinnerService.activarLoading(true);
    this.versionService.obtenerGlosaMaster(52).subscribe((resp:any)=>{
      this.spinnerService.activarLoading(false);
      this.glosa52=resp.body.glosa.split('\n');
    },error=>{
      this.spinnerService.activarLoading(false);
      console.log('Error',error.error);
    })
  }
}
